import { useActiveJackpot } from '@hooks/jackpot/useActiveJackpot'
import { JACKPOT_MESSAGES, JACKPOT_VIEW_TYPE } from '@constants/jackpotConstants'
import SpinningLoader from '../../../../../components/loaders/SpinningLoader'
import JackpotDetail from './JackpotDetail'

// Exactly one active jackpot can exist per brand at a time — so unlike
// JackpotHistoryTab (a clickable list of cards), there's no list/card step
// here at all. The detail screen renders directly the moment one exists.
// Shares its query with the header bar + main-layout message (useActiveJackpot).
const ActiveJackpotTab = () => {
  const { jackpot, isActive, isPending, isError } = useActiveJackpot()

  if (isPending) {
    return (
      <div className="standard-normal-jackpot-tab-outer-container">
        <SpinningLoader />
      </div>
    )
  }

  if (isError || !isActive) {
    return (
      <div className="standard-normal-jackpot-tab-outer-container">
        <div className="standard-normal-jackpot-tab-empty-message">
          {isError ? 'Ooops! Something Went Wrong!' : JACKPOT_MESSAGES.NO_ACTIVE_JACKPOT}
        </div>
      </div>
    )
  }

  return (
    <div className="standard-normal-jackpot-tab-detail-container">
      <JackpotDetail jackpot={jackpot} viewType={JACKPOT_VIEW_TYPE.ACTIVE} />
    </div>
  )
}

export default ActiveJackpotTab
